// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  ToggleAction,
  Title,
  TileWrapper,
  Collapsible,
  Description,
  Image,
  Price as StyledPrice,
} from '../optionPriceExtended/atoms';
import { toggleUiBooleanSetting, getUiSetting } from '../../../../store/uiStore';
import {
  List,
  type ListItem,
  TotalPrice,
  BundlePrice,
} from './atoms';
import {
  getConfigChoiceCollapsedButtonText,
  getConfigChoiceExpandedButtonText,
  getPerMonthAbbrv,
} from '../../../../store/configuratorSettings/selectors';
import {
  getBundlePrice,
} from '../../../../store/pdb/selectors';

type OwnProps = {|
  id: string | number, // eslint-disable-line react/no-unused-prop-types
  title: string,
  price: number,
  imageUrl: ?string,
  description: string,
  active: boolean,
  extras?: Array<ListItem>,
|};


type StateProps = {|
  open: boolean,
  openInfo: string,
  closeInfo: string,
  extraPrice: number,
  postfix: string,
|};

type DispatchProps = {|
  toggle: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const OptionBundle = ({
  extraPrice,
  title,
  price,
  description,
  imageUrl,
  active,
  open,
  toggle,
  openInfo,
  closeInfo,
  extras,
  postfix,
// $FlowFixMe
}: Props) => (
  <TileWrapper>
    <Title active={active}>
      {title}
    </Title>
    <StyledPrice
      active={active}
    >
      <TotalPrice
        amount={extraPrice}
        displayPrefix
        displayCurrencyText
      />
      <BundlePrice
        amount={price}
        displayPrefix
        displayCurrencyText
        postfix={postfix}
      />
    </StyledPrice>
    <List
      listStyle="icons"
      items={extras}
      compact
    />
    {(imageUrl || description) && [
      <Collapsible
        key="collapsible"
        open={open}
      >
        {imageUrl && <Image src={imageUrl} alt={title} />}
        <Description
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Collapsible>,
      <ToggleAction
        key="toggle-action"
        onClick={evt => {
          evt.stopPropagation();
          toggle();
        }}
        label={open === true ? `${closeInfo}` : `${openInfo}`}
        open={open}
      />,
    ]}
  </TileWrapper>
);

OptionBundle.defaultProps = {
  extras: [],
};

const mapStateToProps = (state, ownProps: OwnProps): StateProps => ({
  open: getUiSetting(state, `extendedOptionPrice-${ownProps.id}`),
  openInfo: getConfigChoiceCollapsedButtonText(state),
  closeInfo: getConfigChoiceExpandedButtonText(state),
  extraPrice: getBundlePrice(state, parseInt(ownProps.id, 10)),
  postfix: getPerMonthAbbrv(state),
});

const mapDispatchToProps = (dispatch: Function, ownProps: OwnProps): DispatchProps => ({
  toggle: () => dispatch(toggleUiBooleanSetting(`extendedOptionPrice-${ownProps.id}`)),
});

export default connect<any, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(OptionBundle);
